import { render } from "./ModalWelcome.vue?vue&type=template&id=7cad5813"
import script from "./ModalWelcome.vue?vue&type=script&lang=js"
export * from "./ModalWelcome.vue?vue&type=script&lang=js"

import "./ModalWelcome.vue?vue&type=style&index=0&id=7cad5813&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__